import {Brand, BrandCode} from '../types'
import {brands} from './brands'

interface DefaultBrand extends Omit<Brand, 'helpUrl'> {
  helpUrl: string
}

export {brands}

export const defaultBrandCode = 'vio' as BrandCode
export const defaultBrand = brands[defaultBrandCode] as DefaultBrand

/**
 * @param code - The brand code
 * @returns The brand object
 */
export const getBrandByCode = (code: string): Brand => brands[code as BrandCode]
